export const videoExplicativoUrl: string = 'www.youtube.com/embed/L9tykrmtXDE';
export const videoRealizandoEscolhasUrl: string = 'www.youtube.com/embed/hjYK6W18C5Q';
export const videoAlfabetizacao360: string = 'www.youtube.com/embed/Y9oXSaqCXHA';
export const videoCriatividadeDetail: string = 'www.youtube.com/embed/rlmFFLU2-Wc'
